import { useContext } from "react";
import { BillingInformationContext } from "../../../../Account/BillingInformation/BillingInformationContext";
export const useCreditCardField = () => {
    const { customerCreditCards } = useContext(BillingInformationContext);
    const creditCardSelectOptions = customerCreditCards === null || customerCreditCards === void 0 ? void 0 : customerCreditCards.map((c) => {
        var _a, _b, _c, _d, _e, _f;
        const unselectedLabel = `${(_a = c === null || c === void 0 ? void 0 : c.card) === null || _a === void 0 ? void 0 : _a.brand} ****${(_b = c === null || c === void 0 ? void 0 : c.card) === null || _b === void 0 ? void 0 : _b.last4} Exp ${(_d = (_c = c === null || c === void 0 ? void 0 : c.card) === null || _c === void 0 ? void 0 : _c.expiration) === null || _d === void 0 ? void 0 : _d.month}/${(_f = (_e = c === null || c === void 0 ? void 0 : c.card) === null || _e === void 0 ? void 0 : _e.expiration) === null || _f === void 0 ? void 0 : _f.year} ${c.isPrimary ? "*Primary" : ""}`;
        return {
            value: c.id,
            selectedLabel: `${c.card.brand} ****${c.card.last4}`,
            unselectedLabel,
        };
    });
    return { creditCardSelectOptions };
};
